<div class="detail-body">
    <div class="detail-documents relevant-info">
        <h2>
            {{ 'REQUEST_DETAIL.DOCUMENTS_ANALYZED' | translate }}
        </h2>

        <div class="detail-content">
            <div class="detail-content-header">
                <span class="material-symbols-outlined custom-doc ">description</span>
                <h3>{{ 'REQUEST_DETAIL.ENRICHMENT' | translate }}</h3>

                <div class="accordion-buttons">
                    <!-- EXPAND ALL BUTTON -->
                    <p-button
                        *ngIf="standardRequestDetailDocumentsService.enrichmentAccordion.length > 0 && standardRequestDetailDocumentsService.activedAccordionItems.length !== standardRequestDetailDocumentsService.enrichmentAccordion.length"
                        [disabled]="standardRequestDetailDocumentsService.activedAccordionItems.length === standardRequestDetailDocumentsService.enrichmentAccordion.length"
                        (click)="standardRequestDetailDocumentsService.expandAll()"
                        pTooltip="{{ 'REQUEST_DETAIL.EXPAND_ALL' | translate }}" tooltipPosition="top"
                        styleClass="p-button-rounded p-button-secondary p-button-text"
                    >
                        <span class="material-symbols-outlined"> keyboard_arrow_down </span>
                    </p-button>

                    <!-- COLLAPSE ALL BUTTON -->
                    <p-button
                        *ngIf="standardRequestDetailDocumentsService.enrichmentAccordion.length > 0 && standardRequestDetailDocumentsService.activedAccordionItems.length !== 0"
                        [disabled]="standardRequestDetailDocumentsService.activedAccordionItems.length === 0"
                        (click)="standardRequestDetailDocumentsService.colapseAll()"
                        pTooltip="{{ 'REQUEST_DETAIL.COLLAPSE_ALL' | translate }}" tooltipPosition="top"
                        styleClass="p-button-rounded p-button-secondary p-button-text"
                    >
                        <span class="material-symbols-outlined"> keyboard_arrow_up </span>
                    </p-button>
                </div>
            </div>

            <div class="">
                <p-accordion [multiple]="true" [(value)]="standardRequestDetailDocumentsService.activedAccordionItems">
                    <p-accordion-panel
                        *ngFor="let enrichment of standardRequestDetailDocumentsService.enrichmentAccordion; let i = index"
                        [value]="i"
                        (onOpen)="standardRequestDetailDocumentsService.onTabOpen(i)"
                        (onClose)="standardRequestDetailDocumentsService.onTabClose(i)"
                    >
                        <p-accordion-header>
                            {{ enrichment.title | translate }}
                        </p-accordion-header>
                        <p-accordion-content>
                        <table>
                            <thead>
                                <th>{{ 'REQUEST_DETAIL.KEY' | translate }}</th>
                                <th>{{ 'REQUEST_DETAIL.VALUE' | translate }}</th>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let e of enrichment.elements">
                                    <tr>
                                        <td class="W330">{{ e.key | translate }}</td>
                                        @if (e.key === 'REQUEST_DETAIL.LABORAL.ACTIVE_SITUATION') {
                                            <td>
                                                <span>{{ 'REQUEST_DETAIL.LABORAL.REGIME' | translate }}: {{ e.value['regime'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.LABORAL.EMPLOYER' | translate }}: {{ e.value['title'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.LABORAL.PERIOD' | translate }}: {{ e.value['dateStart'] | date: 'dd/MM/yyy' }} - ...</span>
                                            </td>
                                        } @else if (e.key === 'REQUEST_DETAIL.STANDARD_ENRICHMENT.OD_RATING') {
                                            <td class="od-rating-container">
                                                <div class="od-rating">
                                                    @for (orc of odRatingCells; track $index) {
                                                        <span
                                                            class="rating-cell"
                                                            [class]="getClassFromValue(orc)"
                                                            [ngClass]="{ 'opacity-30': applyOpacity(e.value, orc) }"
                                                            [pTooltip]="'OD_RATING_TOOLTIP.' + orc | translate" tooltipPosition="top"
                                                        >
                                                            {{ 'OD_RATING.' + orc | translate }}
                                                        </span>
                                                    }
                                                </div>
                                            </td>
                                        } @else if (e.key === 'REQUEST_DETAIL.STANDARD_ENRICHMENT.TITLES.DATOSEMPLEADOR') {
                                            <td>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.DENOMINACIONSOCIAL' | translate }}: {{ e.value['denominacionSocial'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.CIF' | translate }}: {{ e.value['cif'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.TELEFONO' | translate }}: {{ e.value['telefono'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.URLWEB' | translate }}: {{ e.value['urlweb'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.OD_EMAIL' | translate }}: {{ e.value['OD_Email'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.DOMICILIOSOCIAL' | translate }}: {{ e.value['domicilioSocial'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.ACTIVA' | translate }}: {{ e.value['Activa'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.OD_CODFORMAJURIDICAEXTENDIDA' | translate }}: {{ e.value['OD_CodFormaJuridicaExtendida'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.OD_CODIGOFORMASOCIAL' | translate }}: {{ e.value['OD_CodigoFormaSocial'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.ANTIGUEDADEMPRESA' | translate }}: {{ e.value['antiguedadEmpresa'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.OD_CODCOMUNIDADAUTONOMA' | translate }}: {{ e.value['OD_CodComunidadAutonoma'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.OD_SECTORCBBE' | translate }}: {{ e.value['OD_SectorCBBE'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.OD_CNAE4DCOMPLETO' | translate }}: {{ e.value['OD_Cnae4DCompleto'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.OD_FECHACONSTITUCION' | translate }}: {{ e.value['OD_FechaConstitucion'] }}</span>
                                                <br>
                                                <span>{{ 'REQUEST_DETAIL.DATOSEMPLEADOR.OD_RATINGAXESORDEF' | translate }}: {{ e.value['OD_RatingAxesorDef'] }}</span>
                                                <br>
                                            </td>
                                        } @else {
                                            @if(isNumber(e.value)){
                                                <td>{{ +e.value | number:'1.0-2':'es-ES' }}</td>
                                            }@else {
                                                <td>{{ translate(e.value) }}</td>
                                            }
                                        }
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
            </div>
        </div>
    </div>

    <app-detail-documents class="detail-documents" headerLabel="REQUEST_DETAIL.REQUEST_RECEIVED_DOCUMENTS" contentLabel="REQUEST_DETAIL.TAX_DOCUMENTATION" [detail]="standardRequestDetailService.request" [toRemove]="documentNamesToRemove" />
</div>
